module.exports = __webpack_public_path__ + "img/lordsmobile-guide.75219f9.jpg";